import React from 'react';
import { Route, NotFound } from 'cccisd-laravel-boilerplate';
import defaultProps from 'recompose/defaultProps.js';
import { Switch } from 'cccisd-react-router';
import { AdminRoutes, Manage as AppdefManage } from 'cccisd-laravel-appdefs';
import { ResourceCenterWithCollection } from 'cccisd-laravel-resources-share';
import { ResourceCenter } from 'cccisd-laravel-resources';
import StyledResourceCenter from './components/StyledResourceCenter';
import { AuthRedirect } from 'cccisd-laravel-nexus';
import { Quest } from 'cccisd-laravel-assignment';
import { OrgAdminDash, GUAdminDash, SiteAdminDash, SupervisorDash } from 'js/assessment';
import SecureMessagingProvider from './pages/SecureMessaging/SecureMessagingProvider';
import SecureMessagingSupervisor from './pages/SecureMessaging/SecureMessagingSupervisor';

// Layouts
import MainLayout from './layouts/MainLayout';
import QuestLayout from './layouts/QuestLayout';
import CvSideNavLayout from './layouts/CvSideNavLayout';

// Pages
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import Welcome from './pages/Welcome';
import DeploymentCenter from './pages/DeploymentCenter';
import AssignmentPlanPlayer from './pages/AssignmentPlan';
import ComingSoon from './pages/ComingSoon';
import CvLogin from './pages/CvLogin';
import Administer from './pages/Administer';
import RolePicker from './pages/RolePicker';
import SessionPlayer from './pages/SessionPlayer';
import HelpCenter from './pages/HelpCenter';
import Flags from './pages/Flags';
import Results from './pages/Results';
import ImmediateCvRedirect from './pages/ImmediateCvRedirect';

//
import SearchTest from './pages/SearchTest';

// Laravel packages
import Nexus from 'bundle-loader?lazy!cccisd-laravel-nexus';

// Bind MainLayout by default
const AppRoute = defaultProps({ layout: MainLayout })(Route);

const MainLayoutFluid = defaultProps({ className: 'container-fluid' })(MainLayout);

let Fortress = window.cccisd.fortress;
let AppDefinitions = window.cccisd.appDefs;

const componentMatch = {
    AppdefManage,
    Welcome,
    ResourceCenter,
    StyledResourceCenter,
    ResourceCenterWithCollection,
    DeploymentCenter,
    AssignmentPlanPlayer,
    Administer,
    ComingSoon,
    Flags,
    Results,
    OrgAdminDash,
    GUAdminDash,
    SiteAdminDash,
    SupervisorDash,
    HelpCenter,
    SecureMessagingProvider,
    SecureMessagingSupervisor,
};

const layoutMatch = {
    MainLayout,
    MainLayoutFluid,
    CvSideNavLayout,
};

export default () => (
    <Switch>
        {AppDefinitions.routes.map(route => {
            const Component = componentMatch[route.componentHandle];
            if (!Component) {
                return null;
            }

            return (
                <AppRoute
                    key={route.handle}
                    path={route.url}
                    component={Component}
                    componentProps={route.componentProps}
                    exact
                    layout={
                        'layout' in route && layoutMatch[route.layout] ? layoutMatch[route.layout] : MainLayoutFluid
                    }
                />
            );
        })}

        {/* Only 5 Potential Guest routes */}
        <AppRoute path="/" component={Welcome} exact layout={CvSideNavLayout} />
        <AppRoute path="/login" component={Welcome} layout={CvSideNavLayout} />
        <AppRoute path="/cvlogin" component={CvLogin} layout={CvSideNavLayout} />
        <AppRoute
            path="/sessionPlayer/:deploymentId/:assignmentPlanId/:sessionId/:reporter/:pawnId/:pawnHash"
            component={SessionPlayer}
            componentProps={{
                errorLayout: MainLayoutFluid,
            }}
            layout={CvSideNavLayout}
        />
        {/* Includes /viewshare resource route */}
        {AdminRoutes(MainLayoutFluid)}

        {/* All other guest traffic gets redirected to Centervention */}
        {!Fortress.auth() && <Route path="/*" component={ImmediateCvRedirect} layout={null} />}

        <AppRoute path="/welcome" component={Welcome} layout={CvSideNavLayout} />
        <AppRoute path="/my-account" component={RolePicker} layout={CvSideNavLayout} />
        <AppRoute path={['/quest/preview', '/d', '/survey']} component={Quest} layout={QuestLayout} />
        <AppRoute
            path="/results/:pawnId"
            component={Results}
            componentProps={{
                errorLayout: MainLayout,
            }}
            layout={CvSideNavLayout}
        />
        <AppRoute
            path="/administer/:pawnId"
            component={Administer}
            componentProps={{
                errorLayout: MainLayout,
            }}
            layout={CvSideNavLayout}
        />
        <AppRoute path="/searchtest" component={SearchTest} layout={CvSideNavLayout} />
        <AppRoute
            path="/help/:tab?/:id?"
            component={HelpCenter}
            componentProps={{
                errorLayout: MainLayoutFluid,
            }}
            layout={CvSideNavLayout}
        />

        <AppRoute
            path="/account"
            layout={CvSideNavLayout}
            component={Nexus}
            componentProps={{ defaultLayout: MainLayout, registrationSurveyLayout: MainLayout }}
        />

        <AppRoute path={Fortress.settings.config.after_login_url} component={AuthRedirect} exact />

        {/* Not found page */}
        <AppRoute component={NotFound} layout={CvSideNavLayout} />
    </Switch>
);
